import { FC, useState, useEffect, useMemo } from 'react';

import cls from 'classnames';

import { useTranslation } from 'next-i18next';
import collapsibleIcon from '../../../assets/Chat/collapsible.png';
import _styles from './index.module.scss';
import { LocalImage } from '../../Image';

interface IntroMessage {
  txt?: string;
  discarded?: boolean;
}

export const Introduction: FC<IntroMessage> = ({ txt, discarded }) => {
  const { t } = useTranslation();

  const [isCollapsible, setIsCollapsible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (txt && txt?.length > 90) setIsCollapsible(true);
  }, [txt]);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  const content = useMemo(() => {
    if (isCollapsible) {
      if (expanded) {
        return (
          <>
            <span>{`${txt?.slice(0, 90)}...` || '...'}</span>
            <span className={_styles.collapsible} onClick={toggleExpanded}>
              <LocalImage src={collapsibleIcon} />
            </span>
          </>
        );
      } else {
        return (
          <>
            <span>{txt || '...'}</span>
            <span className={cls([_styles.collapsible, _styles.expanded])} onClick={toggleExpanded}>
              <LocalImage src={collapsibleIcon} />
            </span>
          </>
        );
      }
    }
    return <span>{txt || '...'}</span>;
  }, [isCollapsible, txt, expanded]);

  return (
    <div className={cls([_styles.introduction, discarded ? _styles.discarded : ''])}>
      <h2 className={_styles.content}>
        <span className={_styles.title}>{t('edit_chat_preview_intro_title')}&nbsp;</span>
        {content}
      </h2>
    </div>
  );
};
